import { Injectable } from '@angular/core';
import { RotateCardContentViewModel } from '../../../base/rotate-card-content-view-model';
import { distinctUntilChanged, map, startWith } from 'rxjs/operators';

@Injectable()
export class RenderCardBackgroundViewModel extends RotateCardContentViewModel {
  public allowPrintCardBackgroundInflatorOverflow$ = this.data$.pipe(
    map(data => data?.allowPrintCardBackgroundInflatorOverflow()),
    startWith(false),
    distinctUntilChanged()
  );
}
